import cx from 'classnames';
import type { FC } from 'react';

import type { IconName } from '@zen/Styleguide';

import Icon from '../../../Icon';

interface Props {
  backgroundColor: string;
  color: string;
  name: IconName;
}

const CheckboxCardIcon: FC<Props> = ({ backgroundColor, color, name }) => {
  const classNames: string = cx(backgroundColor, 'flex h-6 w-6 items-center justify-center rounded');
  const iconClassNames: string = cx(color, 'text-xs');

  return (
    <div className={classNames} data-component="checkbox-card-icon" data-testid="checkbox-card-icon">
      <Icon className={iconClassNames} icon={name} />
    </div>
  );
};

export type { Props as CheckboxCardIconProps };
export default CheckboxCardIcon;
